document.addEventListener('DOMContentLoaded', function() {
    const phoneInputs = document.querySelectorAll('.wpcf7-tel');

    if (phoneInputs.length === 0) {
        return;
    }

    phoneInputs.forEach(phoneInput => {
        phoneInput.addEventListener('input', function(e) {
            let value = e.target.value;

            // Удаляем все нецифровые символы
            value = value.replace(/\D/g, '');

            // Ограничиваем длину до 11 символов (например, для номеров РФ)
            if (value.length > 11) {
                value = value.slice(0, 11);
            }

            e.target.value = value;
        });
    });
});

